export default __webpack_public_path__ + "static/media/walletconnect.a4166a89.svg";